import { render, staticRenderFns } from "./abstract-notification.vue?vue&type=template&id=0826506d&scoped=true"
import script from "./abstract-notification.vue?vue&type=script&lang=js"
export * from "./abstract-notification.vue?vue&type=script&lang=js"
import style0 from "./abstract-notification.vue?vue&type=style&index=0&id=0826506d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826506d",
  null
  
)

export default component.exports